module.exports = __webpack_public_path__ + "img/code-analysis.3b778450.jpeg";